import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class JitsiLoadService {
    private scriptLoaded = false;

    preloadJitsi(): Promise<void> {
        return new Promise((resolve, reject) => {
            if (this.scriptLoaded) {
                resolve();
                return;
            }

            const script = document.createElement('script');
            script.src = 'https://meet.jit.si/external_api.js';
            script.onload = () => {
                this.scriptLoaded = true;
                resolve();
            };
            script.onerror = reject;
            document.head.appendChild(script);
        });
    }

    isLoaded(): boolean {
        return this.scriptLoaded;
    }
}